export const dateIsValid = (date: unknown): date is Date => {
	return date instanceof Date && !isNaN(date as unknown as number);
};

export const yearToDisplayText = (date: Date | undefined, defaultText = '') => {
	if (!dateIsValid(date)) {
		return defaultText;
	}

	return date.getFullYear();
};
